import { Routes, Route, Navigate } from 'react-router-dom';

import { useReactiveVar } from '@apollo/client/react';

import Documents from './views/Documents/Documents';
import Projects from './views/Projects/Projects';
import NewProject from './views/NewProject/NewProject';
import ProjectOverview from './views/ProjectOverview/ProjectOverview';
import Billing from './views/Billing/Billing';
import PaymentSuccess from './views/PaymentSuccess/PaymentSuccess';
import NotFound from './views/NotFound/NotFound';
import { Box, Loading, Typography } from '@brainpool/components';
import { CreateOrganization } from '@clerk/react';
import { reactiveVars, OrganizationProps } from '@brainpool/apollo-connect';
import { PageContainer } from './components';

export function TuneddRoutes() {
  const organization = useReactiveVar<OrganizationProps | null>(reactiveVars.organization);
  const isLoading = useReactiveVar<boolean>(reactiveVars.isLoading);

  return (
    <>
      <Loading open={isLoading} />
      {!organization ? (
        <PageContainer>
          <Box sx={{ flexDirection: 'column', justifyItems: 'center' }}>
            <Typography variant="h1" sx={{ mb: 2, textAlign: 'center', py: 4 }}>
              Welcome to Tunedd
              <br />
              Please create an organization
            </Typography>
            <CreateOrganization />
          </Box>
        </PageContainer>
      ) : (
        <Routes>
          <Route path="/" element={<Navigate to="/projects" />} />
          <Route path="/new-project" element={<NewProject />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/billing/success" element={<PaymentSuccess />} />
          <Route path="/documents/:id" element={<Documents />} />
          <Route path="/projects/:id" element={<ProjectOverview />} />
          {/** Catch-all route - redirect any unmatched paths to NotFound */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      )}
    </>
  );
}

export default TuneddRoutes;
